import { render, staticRenderFns } from "./ModelFilesList.vue?vue&type=template&id=c16bdb7e&scoped=true&"
import script from "./ModelFilesList.vue?vue&type=script&lang=js&"
export * from "./ModelFilesList.vue?vue&type=script&lang=js&"
import style0 from "./ModelFilesList.vue?vue&type=style&index=0&id=c16bdb7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16bdb7e",
  null
  
)

component.options.__file = "ModelFilesList.vue"
export default component.exports